import * as yup from 'yup';

/**
 * Yup validation schema for video identification form validation.
 * Non-required fields are received and sent as nulls to the backend, so these fields are nullable.
 */
export const videoIdentificationValidationSchema = yup.object().shape({
  name: yup.object().shape({
    firstName: yup.string().nullable().required('Please provide a first name'),
    lastName: yup.string().nullable().required('Please provide a last name'),
    gender: yup.string().nullable().required('Please provide a gender'),
  }),
  nationalities: yup.string().nullable().required('Please provide a nationality'),
  mobileNumbers: yup.string().nullable().required('Please provide a mobile number'),
  eMailAddresses: yup.string().nullable().required('Please provide an e-Mail'),
  dateOfBirth: yup.date().nullable().required('Please provide a date of birth'),
  businessRelationshipNumbers: yup.string().nullable().required('Please provide a BR'),
  legalInformation: yup.boolean().oneOf([true], 'Legal information field must be checked'),
  generalBankingConditions: yup.boolean().oneOf([true], 'General Banking Condition field must be checked'),
  clmUserInfo: yup.object().shape({
    emailAddress: yup.string().nullable().required('Please provide a RM e-mail'),
    fullName: yup.string().nullable().required('Please provide a RM name'),
    uNumber: yup.string().nullable().required('Please provide a RM uNumber'),
  }),
  advisoryLocationConfirmation: yup.boolean().oneOf([true], 'Advisory Location field must be checked'),
});
